// 70th Anniversary Header JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const hamburgerButton = document.querySelector('.anniversary70-header-hamburger');
  const drawer = document.getElementById('anniversary70-drawer');
  const drawerOverlay = document.querySelector('.anniversary70-drawer-overlay');
  const drawerClose = document.querySelector('.anniversary70-drawer-close');
  
  // ドロワーを開く
  function openDrawer() {
    hamburgerButton.setAttribute('aria-expanded', 'true');
    drawer.classList.add('is-open');
    document.body.classList.add('menu-open');
  }
  
  // ドロワーを閉じる
  function closeDrawer() {
    hamburgerButton.setAttribute('aria-expanded', 'false');
    drawer.classList.remove('is-open');
    document.body.classList.remove('menu-open');
  }
  
  if (hamburgerButton && drawer) {
    // ハンバーガーボタンクリック
    hamburgerButton.addEventListener('click', function() {
      const isExpanded = hamburgerButton.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
    
    // オーバーレイクリック
    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', closeDrawer);
    }
    
    // 閉じるボタンクリック
    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }
  }
  
  // ドロワーナビゲーションリンククリック時に閉じる
  const drawerNavLinks = document.querySelectorAll('.anniversary70-drawer-nav-link');
  drawerNavLinks.forEach(link => {
    link.addEventListener('click', function() {
      closeDrawer();
    });
  });
  
  // ドロワーナビゲーションのスムーススクロール処理
  drawerNavLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href && href.startsWith('#')) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        closeDrawer();
        
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          const headerHeight = document.querySelector('.anniversary70-header').offsetHeight;
          const targetPosition = targetElement.offsetTop - headerHeight - 20;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    }
  });
});